document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.pl-filters').forEach((filterGroup) => {
    const wrapper = filterGroup.closest('[id^="collection-"]');
    if (!wrapper) return;
    const items = wrapper.querySelectorAll('.grid__item[data-product-category]');
    const tabs = filterGroup.querySelectorAll('.pl-filter-tab');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const filter = tab.dataset.filter;

        tabs.forEach((t) => {
          const active = t === tab;
          t.classList.toggle('pl-filter-tab--active', active);
          t.setAttribute('aria-pressed', active);
        });

        items.forEach((item) => {
          const show = filter === 'all' || item.dataset.productCategory === filter;
          item.classList.toggle('pl-filter-hidden', !show);
        });
      });
    });
  });
});
